import e, { useContext as n } from "react";
var o = /* @__PURE__ */ ((t) => (t.Ru = "ru", t.En = "en", t.Uz = "uz", t))(o || {});
const r = e.createContext({
  clientId: "",
  apiRoot: "",
  language: "ru",
  prevStage: null,
  setAppHandlers: () => {
  }
});
function c() {
  return n(r);
}
export {
  r as AppContext,
  o as LanguageEnum,
  c as useAppContext
};
